import { create } from 'zustand';

interface TaskCompletedAnimations {
  pending: boolean;
}

export const useTaskCompletedAnimations = create<TaskCompletedAnimations>(() => ({ pending: false }));

export const showTaskCompletedAnimation = (): void => {
  useTaskCompletedAnimations.setState((state) => (state.pending ? state : { pending: true }));
};

export const dismissTaskCompletedAnimation = (): void => {
  useTaskCompletedAnimations.setState({ pending: false });
};
